import uvers from './uvers';

export default ({
  ...uvers(),
});
